import { useMemo } from 'react';

import { EventMutationTradeProps } from '../event-mutation';
import { EventSellSharesInput } from './event-sell-shares-input';
import EventSellProfitMultiplierRow from './rows/event-sell-profit-multiplier-row';
import EventSellProfitRow from './rows/event-sell-profit-row';
import { EventSellReceive } from './rows/event-sell-receive';

import { ORDER_TYPE } from '@/constants/solana';
import { calculateMarketOrderFill, mapOrderbook } from '@/lib/utils';
import { useOrderbookStore } from '@/store/orderbook';

export const EventMutationSellMarket = ({
  outcome,
  setOutcome,
  id,
  shares,
  orderbookData,
  setShares,
}: EventMutationTradeProps & {
  orderbookData: ReturnType<typeof mapOrderbook>;
}) => {
  const { setPrice } = useOrderbookStore();
  const { averagePrice, totalCost, nextBestPrice } = useMemo(() => {
    const data = calculateMarketOrderFill(
      orderbookData,
      shares,
      ORDER_TYPE.SELL,
    );
    if (Number(data.averagePrice) > 0) {
      setPrice(Math.ceil(Number(data.averagePrice)).toString());
    }
    return data;
  }, [shares, orderbookData, setPrice]);

  return (
    <>
      <EventSellSharesInput
        id={id}
        outcome={outcome}
        shares={shares}
        setShares={setShares}
        matchingAmount={null}
      />
      <div className="border border-[#212121]" />
      <div className="flex flex-col gap-2">
        {/* <EventAveragePriceRow averageLimitPrice={averagePrice} /> */}
        <EventSellProfitRow
          price={averagePrice}
          shares={shares}
          id={id}
          outcome={outcome}
          averageOrderPrice={+averagePrice}
        />
        <EventSellProfitMultiplierRow
          price={averagePrice}
          shares={shares}
          id={id}
          outcome={outcome}
          averageOrderPrice={+averagePrice}
        />
      </div>

      <div className="border border-[#212121]" />
      <EventSellReceive
        marketId={id}
        receiveAmountWithoutFee={totalCost}
        price={null}
        nextBestPrice={nextBestPrice}
        matchingAmount={totalCost}
        tradeType="sell"
        avgPrice={averagePrice}
      />
    </>
  );
};
